import { cn } from '@/lib/utils';

interface SenderStepTimelineProps {
	steps: readonly string[];
}

export default function SenderStepTimeline({ steps }: SenderStepTimelineProps) {
	return (
		<ol className='flex flex-col gap-0'>
			{steps.map((step, index) => (
				<li key={step} className='flex gap-3'>
					<div className='flex flex-col items-center'>
						<span
							className={cn(
								'flex size-7 shrink-0 items-center justify-center rounded-full text-[13px] font-medium',
								'bg-primary/15 text-primary',
							)}
						>
							{index + 1}
						</span>
						{index < steps.length - 1 ? (
							<span className='my-1 w-px flex-1 min-h-4 bg-border' aria-hidden />
						) : null}
					</div>
					<p className='pb-4 pt-0.5 text-[15px]'>{step}</p>
				</li>
			))}
		</ol>
	);
}
